import React from "react";
import ErrorMessage from "./errorMessage";

const CustomInput = ({
  name,
  label,
  type = "text",
  error,
  className,
  onlyNumber,
  inputClass,
  autoComplete = "off",
  ...restProps
}) => {
  const onKeyPress = (event) => {
    /* istanbul ignore else */
    if (!/[0-9]/.test(event.key) && onlyNumber) event.preventDefault();
  };
  return (
    <div className={`w-100 d-flex flex-column  ${className ? className : ""}`}>
      <label
        className="label-default-style"
        htmlFor={name}
        style={{ color: error ? "#cb061d" : "#333" }}
      >
        {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        className={`input input--text input-w-aux__input input--active ${
          inputClass ? inputClass : ""
        } ${error ? "input-error" : ""}`}
        onKeyPress={onKeyPress}
        autoComplete={autoComplete}
        {...restProps}
      />
      {error && <ErrorMessage error={error} />}
    </div>
  );
};

export default CustomInput;
